import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { HicreaSsoChangePasswordSentComponent } from './aiss-sso-change-password-sent/aiss-sso-change-password-sent.component';
import { HicreaSsoForgotPasswordComponent } from './aiss-sso-forgot-password/aiss-sso-forgot-password.component';
import { HicreaSsoInputComponent } from './aiss-sso-input/aiss-sso-input.component';
import { HicreaSsoLoginComponent } from './aiss-sso-login/aiss-sso-login.component';
import { HicreaSsoPasswordInputComponent } from './aiss-sso-password-input/aiss-sso-password-input.component';
import { HicreaSsoRegisterResendComponent } from './aiss-sso-register-resend/aiss-sso-register-resend.component';
import { HicreaSsoRegisterSendComponent } from './aiss-sso-register-send/aiss-sso-register-send.component';
import { HicreaSsoRegisterComponent } from './aiss-sso-register/aiss-sso-register.component';
import { HicreaSsoResetPasswordComponent } from './aiss-sso-reset-password/aiss-sso-reset-password.component';
import { HicreaSsoUnblockComponent } from './aiss-sso-unblock/aiss-sso-unblock.component';
import { HicreaSsoComponent } from './aiss-sso/aiss-sso.component';
import { OemService } from './oem.service';

@NgModule({
  declarations: [
    HicreaSsoComponent,
    HicreaSsoLoginComponent,
    HicreaSsoRegisterComponent,
    HicreaSsoUnblockComponent,
    HicreaSsoRegisterResendComponent,
    HicreaSsoRegisterSendComponent,
    HicreaSsoForgotPasswordComponent,
    HicreaSsoResetPasswordComponent,
    HicreaSsoChangePasswordSentComponent,
    HicreaSsoInputComponent,
    HicreaSsoPasswordInputComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    HicreaSsoResetPasswordComponent,
    HicreaSsoComponent,
    HicreaSsoRegisterResendComponent,
    HicreaSsoRegisterSendComponent,
    HicreaSsoUnblockComponent,
    HicreaSsoChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HicreaSsoModule {}
